"use client";

import React, { useMemo, useSyncExternalStore } from "react";
import { QRCodeSVG } from "qrcode.react";

const shareBaseUrl = process.env.NEXT_PUBLIC_SHARE_BASE_URL?.trim() ?? "";

function getInitialQrValue(path: string) {
  if (/^https?:\/\//i.test(path)) return path;

  if (shareBaseUrl) {
    return `${shareBaseUrl.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;
  }

  return path;
}

function subscribeToOrigin() {
  return () => undefined;
}

export default function MediaQrCode({
  path,
  size = 260,
  className = "",
}: {
  path: string;
  size?: number;
  className?: string;
}) {
  const origin = useSyncExternalStore(
    subscribeToOrigin,
    () => window.location.origin,
    () => ""
  );

  const value = useMemo(() => {
    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const normalizedPath = path.startsWith("/") ? path : `/${path}`;

    if (shareBaseUrl) {
      return `${shareBaseUrl.replace(/\/$/, "")}${normalizedPath}`;
    }

    return origin ? `${origin}${normalizedPath}` : getInitialQrValue(path);
  }, [origin, path]);

  return (
    <QRCodeSVG
      value={value}
      size={size}
      level="M"
      bgColor="#fffaf0"
      fgColor="#17110a"
      className={`h-auto max-w-full ${className}`}
    />
  );
}
